"use client";

import { useMemo } from "react";
import { useThoughtsQuery } from "@/features/thoughts";
import {
  buildGetSelectedThoughtDocumentsRequest,
  type GetSelectedThoughtDocumentsRequest,
  mapThoughtToSelectedThoughtDocument,
} from "../api/getSelectedThoughtDocuments";

export default function useSelectedThoughtDocumentsQuery(
  request: GetSelectedThoughtDocumentsRequest,
  { enabled = true }: { enabled?: boolean } = {},
) {
  const thoughtsQuery = useThoughtsQuery(
    buildGetSelectedThoughtDocumentsRequest(request),
    {
      enabled,
    },
  );

  const data = useMemo(
    () =>
      (thoughtsQuery.data ?? []).map((thought) =>
        mapThoughtToSelectedThoughtDocument(thought),
      ),
    [thoughtsQuery.data],
  );

  return {
    ...thoughtsQuery,
    data,
  };
}
